export default "__VITE_ASSET__uFJ4zmdw__"